type Props = {
    message: string
}

export function ErrorModal({ message }: Props) {
    return <div className="modal-content">
        <div className="modal-header">

            <h5 className="modal-title text-dark"><i className="bx bx-error-circle text-danger"></i> An error has occured</h5>
            <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div className="modal-body">
            <p className="bg-label-danger p-3 rounded-3">
                {message}
            </p>
        </div>
    </div>
}